Rx                = require 'ub_wrapped/rx'
h                 = require 'virtual-dom/h'
RxWidget          = require 'ub/rx_widget'
_                 = require 'lodash'


getButtonFromEvent = (ev) ->
  buttonName = publishToButton[ev.type]
  buttonDetails = buttons[buttonName]
  _.merge buttonName: buttonName, buttonDetails

publishToButton =
  neverPublished          : 'unpublished'
  unpublished             : 'unpublished'
  publishSuccess          : 'unpublished'
  publishError            : 'unpublished'

  republishPageDisabled   : 'disabled'
  unpublishing            : 'disabled'
  publishedWithoutChanges : 'disabled'
  republishSuccess        : 'disabled'
  published               : 'disabled'

  republishPageEnabled    : 'enabled'
  readyToRepublish        : 'enabled'
  republishError          : 'enabled'
  publishedWithChanges    : 'enabled'

  publishing              : 'publishing'

  requestRepublish        : 'republishing'
  republishing            : 'republishing'

buttons =
  unpublished:
    className : 'unpublished dsbl'
    getTitle  : "Go to the page overview to publish this page."
    content   : "Unpublished"

  disabled:
    className : 'republish dsbl'
    content   : 'Republish'

  enabled:
    className  : 'republish current'
    content    : 'Republish'
    useHandler : true

  publishing:
    className : 'publishing processing processing-blue'
    content   : 'Publishing...'

  republishing:
    className : 'publishing processing processing-blue'
    content   : 'Republishing...'

# Store singleton latest states - used when calculating publish and save states
previousPublishState = ''
previousSaveState    = ''

processStates = (sources) ->
  saveObs = sources
    .saveObs
    .filter (ev) ->
      ev.type in ['pageUnsaved', 'pageSaveCompleted']

  saveObs.subscribe (event) ->
    previousSaveState = event.type

  publishObs = sources
    .publishObs
    .filter (ev) -> _.has(publishToButton, ev.type)
    .map (ev) ->
      # If the page currently has unsaved changes, prevent the republish button from ever
      # becoming enabled
      if previousSaveState is 'pageUnsaved' and getButtonFromEvent(ev)?.buttonName is 'enabled'
        type: 'republishPageDisabled'
      else
        type: ev.type

  publishObs.subscribe (event) ->
    previousPublishState = event.type

  savesPublishMap = saveObs
    .map (saveEvent) ->
      if previousPublishState in ['neverPublished', 'unpublished']
        # If the page is unpublished, saving shouldn't change the state in any way.
        type: previousPublishState
      else if saveEvent.type is 'pageUnsaved'
        # Else, when a change is made since the last save, disable the republish button.
        type: 'republishPageDisabled'
      else if saveEvent.type is 'pageSaveCompleted'
        # When the save finishes, re-enable the republish button.
        type: 'republishPageEnabled'
      else
        # Else is never reached due to filter above

  return Rx.Observable.merge publishObs, savesPublishMap

getRepublishButton = (linkAttrs, content) ->
  label = h('span.label', content)
  button = h('a.button.action.svg-ico-publish', linkAttrs, label)

  h('div.republish-button-container', button)


class RepublishButton
  render: (data) =>
    {className, title, content, useHandler} = getButtonFromEvent data

    linkAttrs =
      'className' : className
      'title'     : title
      'ev-click'  : if useHandler then @republishHandler else undefined # Explicitly unset to remove handler

    return getRepublishButton(linkAttrs, content)


  widget: (sources, @republishHandler, @initialState) ->
    @eventObs = processStates sources

    new RxWidget @eventObs, @render, @initialState


module.exports = RepublishButton



// WEBPACK FOOTER //
// ./src/lp/editor/buttons/republish-button.coffee